module.exports = require("./promise.js");


//////////////////
// WEBPACK FOOTER
// es6-promise-polyfill (bower component)
// module id = 18
// module chunks = 0 1 2